const classes = { d: 'filter-boxy-outline', e: 'filter-boxy-fill' }

const FilterBoxy = () => {
    return (
        <>
        <style>{'.filter-boxy-outline { fill: none; stroke: #888; stroke-miterlimit: 10; stroke-width: 1.5; } .filter-boxy-fill { fill: #888; }'}</style>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.12 25.12"><g id="a"/><g id="b"><g id="c"><rect className={classes.d} x=".75" y=".75" width="23.62" height="23.62" rx="4.07" ry="4.07"/><path className={classes.e} d="M18.24,5.46H6.88c-.34,0-.54,.38-.36,.66l4.62,7.04c.05,.07,.07,.15,.07,.23v6.15c0,.37,.44,.57,.72,.32l1.83-1.68c.09-.08,.14-.2,.14-.32v-4.48c0-.08,.02-.16,.07-.23l4.62-7.04c.19-.28-.02-.66-.36-.66Z"/></g></g></svg>
        </>
    )
}

export default FilterBoxy
